var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorOnboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3441 2.07519L13.8805 23.3648C13.5029 24.066 12.4971 24.066 12.1195 23.3648L0.655871 2.07519C0.179327 1.19018 1.15976 0.23415 2.03248 0.732847L12.5039 6.71649C12.8113 6.89217 13.1887 6.89217 13.4961 6.71649L23.9675 0.732846C24.8402 0.23415 25.8207 1.19018 25.3441 2.07519Z",
    fill: "#008938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorOnboard);
export default __webpack_public_path__ + "static/media/vendor_onboard.1a392504a36b603afd0dce22b25d7a06.svg";
export { ForwardRef as ReactComponent };